import { Icon, TextButton } from '@joor/design-system'

import { EmptyPayOrdersOverlayTestIds } from '../EmptyPayOrdersOverlay'
import { Body, Container, Header } from './Common.ui'
import { messages } from 'features/Orders/ListView/constants/messages'

export function ErrorOverlay({ onLinkClick }: { onLinkClick: () => void }) {
  return (
    <Container>
      <Icon
        data-testid={EmptyPayOrdersOverlayTestIds.OverlayIconError}
        iconName="reset"
        iconSize="extraLarge"
        plain
      />
      <Header>{messages.errorLayout.header}</Header>
      <Body>
        {messages.errorLayout.body}
        <br />
        {messages.errorLayout.please}{' '}
        {
          <TextButton onClick={onLinkClick}>
            {messages.errorLayout.reload}
          </TextButton>
        }{' '}
        {messages.errorLayout.tryAgain}
      </Body>
    </Container>
  )
}
